import SageScreen from "kit/SageScreen";
import React from "react";
import BalanceMoneyTransfersRecordPage from "./balanceMoneyTransfersRecord/BalanceMoneyTransfersRecordPage";

const BalanceMoneyTransfersRecord: React.FC = () => {
    const [page, setPage] = React.useState(0);

    const incrementPage = React.useCallback(() => {
        setPage(page + 1);
    }, [page, setPage]);

    const decrementPage = React.useCallback(() => {
        setPage(Math.max(0, page - 1));
    }, [page, setPage]);

    return (
        <SageScreen>
            <h2>Transfers Record</h2>
            <p>These are the records of your transfers out of Rend A Hand.</p>
            <BalanceMoneyTransfersRecordPage
                incrementPage={incrementPage}
                page={page}
                decrementPage={decrementPage}
            />
        </SageScreen>
    );
};

export default BalanceMoneyTransfersRecord;
